import {
    UPDATE_MEMBERSHIP_SCHEDULE,
    UPDATE_MEMBERSHIP_SCHEDULE_FAILURE,
    UPDATE_MEMBERSHIP_SCHEDULE_SUCCESS,
} from 'store/actions/types';

export const updateMembershipSchedule = (payload) => {
    return {
        type: UPDATE_MEMBERSHIP_SCHEDULE,
        payload: payload,
    };
};

export const updateMembershipScheduleFailure = (error) => {
    return {
        type: UPDATE_MEMBERSHIP_SCHEDULE_FAILURE,
        error: error,
    };
};

export const updateMembershipScheduleSuccess = (payload, response) => {
    return {
        type: UPDATE_MEMBERSHIP_SCHEDULE_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-schedules/updateMembershipSchedules.js